import { CourseTabDataWithContent, CourseTabGroup, CourseTabDataWithSubtabs } from "@vixi/types";
import { CourseData } from "@vixi/types";
import getStepTitle from "../course/getStepTitle";
import { STEP_TYPE } from "@vixi/types";
import { getI18n } from "@vixi/localization";

const createStepsToStepsTabData = (): ((step: CourseData.Step) => CourseTabDataWithContent) => {
  let conversationCount = 0;
  let stepCount = 0;

  return (step: CourseData.Step) => {
    if (step.type === STEP_TYPE.CONVERSATION) {
      conversationCount++;
      stepCount = 0;
    }
    stepCount++;

    const res: CourseTabDataWithContent = {
      ...step,
      index: conversationCount,
      subIndex: stepCount,
      content: step,
      childrenType: "content",
      title: step.title ?? getStepTitle(step),
    };
    return res;
  };
};

export const courseDataToTabData: (courseData: CourseData.Course) => CourseTabGroup = (
  courseData,
) => {
  const { t, tNum } = getI18n();

  const res = {
    level: "chapters",
    // Map each chapter to a tab
    tabs: courseData.chapters?.map((unit, chapterIndex) => {
      const res: CourseTabDataWithSubtabs = {
        id: unit.id,
        index: chapterIndex,
        childrenType: "subtabs",
        title: unit.title ?? `${t("Course.Chapter")} ${tNum(chapterIndex + 1)}`,

        // Map each lesson to a subtab
        tabList: {
          level: "lessons",
          tabs: unit.lessons.map((lesson, lessonIndex) => {
            const stepToStepTabData = createStepsToStepsTabData();

            const res: CourseTabDataWithSubtabs = {
              id: lesson.id,
              index: lessonIndex,
              childrenType: "subtabs",
              titles: lesson.titles,
              selectedTitle: lesson.selectedTitle,

              // Map each step to a subtab
              tabList: {
                level: "steps",
                tabs: lesson.steps.map(stepToStepTabData),
              } as CourseTabGroup,
            };
            return res;
          }),
        } as CourseTabGroup,
      };
      return res;
    }),
  } as CourseTabGroup;

  return res;
};
